<template>
  <!-- the same footer as on the site (psy-frontend-prod FooterComponent, customer's layout 29.09.2026); site pages are opened on the main site -->
  <footer class="footer" v-if="$route.name !== 'auth'">
    <div class="footer__inner">
      <div class="footer__grid">
        <div class="footer__brand">
          <a :href="siteUrl('/')" class="footer__logo-link">
            <img loading="lazy" class="footer__img" src="../../../public/platformaIcon.png" alt="Платформа" />
            <span class="footer__reg">®</span>
          </a>
          <p class="footer__tagline">{{ $vuetify.lang.t("$vuetify.main.footer.tagline") }}</p>
        </div>

        <nav class="footer__menu">
          <a v-for="link in menuA" :key="link.to" :href="siteUrl(link.to)" class="footer__menu-link">
            {{ $vuetify.lang.t(link.label) }}
          </a>
        </nav>

        <nav class="footer__menu">
          <a v-for="link in menuB" :key="link.to" :href="siteUrl(link.to)" class="footer__menu-link">
            {{ $vuetify.lang.t(link.label) }}
          </a>
        </nav>

        <div class="footer__support">
          <a class="footer__support-btn" href="https://platforma-life-bot.tg.pulse.is" target="_blank" rel="noopener">
            {{ $vuetify.lang.t("$vuetify.main.footer.supportBotText") }}
          </a>
          <!-- the customer's button (09.10.2026): leave a review of Platforma in Google -->
          <a class="footer__rate" href="https://g.page/r/CeXHCJZ39lpeEBM/review" target="_blank" rel="noopener">
            <svg class="footer__rate-g" viewBox="29.6 10.2 25.2 25.4" aria-hidden="true">
              <path fill="#E74336" d="M31,17.34c.27-.46.5-.94.8-1.38a12.37,12.37,0,0,1,9-5.56,12.11,12.11,0,0,1,9.94,3,1.36,1.36,0,0,1,.17.16l-3.64,3.64-.07-.05a7.29,7.29,0,0,0-10,.32,7.79,7.79,0,0,0-1.91,3l-.06.14Z" />
              <path fill="#35A453" d="M35.27,25.48a16.41,16.41,0,0,0,.89,1.78,7.6,7.6,0,0,0,10.45,2.32l.13-.08.28.23,3.83,3a10.16,10.16,0,0,1-3.19,2.06A12.9,12.9,0,0,1,31.16,29c-.05-.08-.08-.17-.12-.25l.17-.13Z" />
              <path fill="#4282F1" d="M50.85,32.71l-3.83-3-.28-.23c.32-.27.66-.52,1-.82a5.62,5.62,0,0,0,1.56-2.89,1,1,0,0,0,0-.12H42.44V20.74h12c0,.39.11.78.15,1.18a14.22,14.22,0,0,1-.94,6.74,11.35,11.35,0,0,1-2.61,3.88Z" />
              <path fill="#F7B906" d="M35.27,25.48l-4.06,3.14-.17.13a11.4,11.4,0,0,1-1.1-3.09,12.57,12.57,0,0,1,1-8.2l.07-.12,4.23,3.27c-.12.58-.27,1.15-.35,1.74a6.73,6.73,0,0,0,.3,2.92C35.24,25.34,35.25,25.41,35.27,25.48Z" />
            </svg>
            <span class="footer__rate-body">
              <svg class="footer__rate-stars" viewBox="61.5 6.4 59.6 10.2" aria-hidden="true">
                <polygon v-for="x in [0, 12.22, 24.43, 36.64, 48.86]" :key="x" fill="#FDC400" :transform="`translate(${x} 0)`" points="66.86 14.81 63.61 16.52 64.23 12.9 61.6 10.34 65.24 9.81 66.86 6.52 68.49 9.81 72.12 10.34 69.49 12.9 70.11 16.52 66.86 14.81" />
              </svg>
              <span class="footer__rate-text">{{ $vuetify.lang.t("$vuetify.main.footer.rateUs") }}</span>
            </span>
          </a>
        </div>

        <!-- official listing of the business on Diia (the customer's request, also a trust signal) -->
        <a class="footer__diia" href="https://pop-up.diia-business.com/uk/businesses/platforma-000000231" target="_blank" rel="noopener">
          <span class="footer__diia-text">{{ $vuetify.lang.t("$vuetify.main.footer.diiaCatalog") }}</span>
          <span class="footer__diia-sep" aria-hidden="true"></span>
          <img class="footer__diia-logo" src="../../assets/images/diia-business.svg" alt="Дія.Бізнес" width="104" height="25" loading="lazy" />
        </a>

        <div class="footer__legal">
          <terms>{{ $vuetify.lang.t("$vuetify.main.footer.agreement") }}</terms>
        </div>
        <div class="footer__legal">
          <personal-data>{{ $vuetify.lang.t("$vuetify.main.footer.privacy") }}</personal-data>
        </div>
        <div class="footer__legal">
          <a class="footer__email" href="mailto:contact@platforma.life">contact@platforma.life</a>
        </div>
      </div>
    </div>

    <div class="footer__bottom">
      <div class="footer__inner footer__bottom-inner">
        <p class="footer__copyright">
          &copy; 2022-{{ new Date().getFullYear() }} ТМ «Платформа».<br />{{ $vuetify.lang.t("$vuetify.main.footer.rights") }}
        </p>
        <div class="footer__social">
          <a
            v-for="item in social"
            :key="item.name"
            :href="item.href"
            :aria-label="item.name"
            class="footer__social-item"
            target="_blank"
            rel="noopener"
          >
            <!-- the icon font has no Telegram logo: its paper plane is drawn inline -->
            <svg v-if="item.name === 'Telegram'" class="footer__tg" viewBox="40 65 140 115" aria-hidden="true">
              <path fill="#FFFFFF" d="M54.3,118.8c35-15.2,58.3-25.3,70-30.2c33.3-13.9,40.3-16.3,44.8-16.4c1,0,3.2,0.2,4.7,1.4c1.2,1,1.5,2.3,1.7,3.3s0.4,3.1,0.2,4.7c-1.8,19-9.6,65.1-13.6,86.3c-1.7,9-5,12-8.2,12.3c-7,0.6-12.3-4.6-19-9c-10.6-6.9-16.5-11.2-26.8-18c-11.9-7.8-4.2-12.1,2.6-19.1c1.8-1.8,32.5-29.8,33.1-32.3c0.1-0.3,0.1-1.5-0.6-2.1c-0.7-0.6-1.7-0.4-2.5-0.2c-1.1,0.2-17.9,11.4-50.6,33.5c-4.8,3.3-9.1,4.9-13,4.8c-4.3-0.1-12.5-2.4-18.7-4.4c-7.5-2.4-13.5-3.7-13-7.9C45.7,123.3,48.7,121.1,54.3,118.8z" />
            </svg>
            <v-icon v-else color="#FFFFFF" :size="item.size">{{ item.icon }}</v-icon>
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import PersonalData from "@/components/UI/personalTerms/personalData";
import Terms from "@/components/UI/personalTerms/terms";

const MAIN_PAGE = (process.env.VUE_APP_MAIN_PAGE || "").replace(/\/$/, "");
const MENU_A = [
  { to: "/about", label: "$vuetify.main.footer.footerMenu.aboutProject" },
  { to: "/psychologist", label: "$vuetify.main.footer.footerMenu.forPsychologists" },
  { to: "/business", label: "$vuetify.main.footer.footerMenu.forBusinessShort" },
  { to: "/faq", label: "$vuetify.main.footer.footerMenu.FAQ" },
];
const MENU_B = [
  { to: "/services", label: "$vuetify.main.footer.footerMenu.services" },
  { to: "/forum", label: "$vuetify.main.footer.footerMenu.askQuestion" },
  { to: "/blog/", label: "$vuetify.main.footer.footerMenu.expertArticles" },
  { to: "/tests", label: "$vuetify.main.footer.footerMenu.tests" },
  { to: "/events", label: "$vuetify.main.footer.footerMenu.events" },
];
const SOCIAL = [
  { name: "Facebook", icon: "mdi-facebook", size: 26, href: "https://www.facebook.com/%D0%9F%D0%BB%D0%B0%D1%82%D1%84%D0%BE%D1%80%D0%BC%D0%B0-110554091618488" },
  { name: "Instagram", icon: "mdi-instagram", size: 26, href: "https://instagram.com/platforma.life?utm_medium=copy_link" },
  { name: "Telegram", href: "https://t.me/+Dqd5L573QkpjMWFi" },
  { name: "WhatsApp", icon: "mdi-whatsapp", size: 24, href: "https://wa.me/380673077887" },
];

export default {
  name: "footerComponent",
  components: { PersonalData, Terms },
  data() {
    return { menuA: MENU_A, menuB: MENU_B, social: SOCIAL };
  },
  methods: {
    siteUrl(path) {
      return MAIN_PAGE + path;
    },
  },
};
</script>

<style lang="scss" scoped>
$teal: #00a3b7;
$text: #585857;

.footer {
  border-top: 2px solid $teal;
  background: #d9e4eb;
  color: $text;
  font-size: 16px;
  line-height: 1.2;
}
.footer__inner {
  // the content is as wide as the site's page container (1200px)
  max-width: 1232px;
  margin: 0 auto;
  padding: 0 16px;
}
.footer__grid {
  display: grid;
  // the link columns start where the customer's layout puts them (32% and 58% of the width), the support column hugs the right edge
  grid-template-columns: 32.4% 25.6% minmax(0, 1fr) auto;
  row-gap: 62px;
  padding: 29px 0 12px;
}
.footer__logo-link {
  display: inline-flex;
  align-items: flex-start;
  text-decoration: none;
}
.footer__img {
  display: block;
  width: 181px;
  height: auto;
}
.footer__reg {
  margin-left: 3px;
  color: $teal;
  font-size: 18px;
  font-weight: 500;
  line-height: 1;
}
.footer__tagline {
  max-width: 260px;
  margin: 10px 0 0;
  font-size: 22px;
  line-height: 1.22;
}
.footer__menu {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding-top: 8px;
}
.footer__menu-link {
  color: $text;
  // the same size as the legal links under the columns (customer, 09.10.2026)
  font-size: 16px;
  line-height: 20px;
  text-decoration: none;
  transition: color 0.2s;
  &:hover {
    color: $teal;
  }
}
.footer__support {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
  padding-top: 11px;
}
.footer__support-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 184px;
  height: 32px;
  border-radius: 8px;
  background: $teal;
  color: #fff;
  text-decoration: none;
  transition: background 0.2s;
  &:hover {
    background: #008c9e;
  }
}
.footer__rate {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 184px;
  height: 40px;
  border: 1px solid $teal;
  border-radius: 8px;
  color: $teal;
  text-decoration: none;
  transition: background 0.2s;
  &:hover {
    background: rgba(0, 163, 183, 0.1);
  }
}
.footer__rate-g {
  flex: 0 0 auto;
  width: 22px;
  height: 22px;
}
.footer__rate-body {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}
.footer__rate-stars {
  display: block;
  width: 52px;
  height: 9px;
}
.footer__rate-text {
  font-size: 15px;
  font-weight: 500;
  line-height: 1;
}
.footer__diia {
  display: inline-flex;
  align-items: center;
  align-self: end;
  justify-self: start;
  gap: 8px;
  color: $teal;
  text-decoration: none;
}
.footer__diia-text {
  white-space: nowrap;
}
.footer__diia-sep {
  width: 1px;
  height: 17px;
  background: $text;
}
.footer__diia-logo {
  display: block;
  width: 104px;
  height: 25px;
}
.footer__legal {
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  ::v-deep .blue-font {
    color: $teal;
    cursor: pointer;
  }
}
.footer__legal ::v-deep .blue-font:hover,
.footer__email:hover {
  color: #008c9e;
}
.footer__legal:last-child {
  justify-content: flex-end;
}
.footer__email {
  color: $teal;
  text-decoration: none;
}
.footer__bottom {
  border-top: 1px solid #bbbbbb;
}
.footer__bottom-inner {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding-top: 15px;
  padding-bottom: 30px;
}
.footer__copyright {
  margin: 0;
  font-size: 16px;
  line-height: 19px;
}
.footer__social {
  display: flex;
  gap: 13px;
}
.footer__tg {
  width: 21px;
  height: 21px;
  margin-left: -2px;
}
.footer__social-item {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: $teal;
  text-decoration: none;
  transition: background 0.2s;
  &:hover {
    background: #008c9e;
  }
}

// tablets: brand + support on top, two link columns, the legal row as a list
@media (max-width: 1199px) {
  .footer__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    row-gap: 24px;
    column-gap: 24px;
  }
  .footer__support {
    order: -1;
    grid-column: 2;
    grid-row: 1;
    padding-top: 0;
  }
  .footer__brand {
    grid-column: 1;
    grid-row: 1;
  }
  .footer__menu {
    align-items: flex-start;
    padding-top: 0;
  }
  .footer__diia {
    grid-column: 1 / -1;
  }
  .footer__legal:last-child {
    justify-content: flex-start;
  }
  .footer__bottom-inner {
    flex-direction: column;
    gap: 14px;
  }
}
@media (max-width: 599px) {
  .footer__grid {
    grid-template-columns: minmax(0, 1fr);
    row-gap: 20px;
    padding-top: 24px;
  }
  .footer__brand,
  .footer__support {
    grid-column: 1;
    grid-row: auto;
  }
  .footer__support {
    order: 0;
    align-items: flex-start;
  }
  .footer__tagline {
    font-size: 20px;
  }
  // the narrowest phones (320px with a scrollbar): the Diia logo goes under its caption instead of sticking out
  .footer__diia {
    flex-wrap: wrap;
    row-gap: 6px;
  }
  .footer__legal + .footer__legal {
    margin-top: -8px;
  }
}
</style>
